"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServiceAreas() {
  const header = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const map = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="11257" id="areas-near-lakeland-we-serve" className="dark bg-background text-foreground border-t border-[var(--border)] py-20 md:py-28">
      <div className="mx-auto max-w-[1320px] px-6 md:px-8">
        
        <div ref={header.ref} className="grid grid-cols-1 lg:grid-cols-12 gap-8" style={{
        opacity: header.isVisible ? 1 : 0,
        transform: header.isVisible ? "translateY(0)" : "translateY(8px)",
        transition: "opacity 420ms cubic-bezier(0.22, 1, 0.36, 1), transform 420ms cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          <div className="lg:col-span-7 flex flex-col gap-6">
            <div className="font-mono uppercase text-[var(--muted-foreground)]" style={{
            fontSize: "clamp(0.6875rem, 0.75vw, 0.75rem)",
            fontWeight: 500,
            letterSpacing: "0.08em"
          }}>SERVICE AREA · LAKELAND FL</div>
            <h2 className="font-default text-[var(--foreground)]" style={{
            fontSize: "clamp(1.875rem, 3.2vw, 2.75rem)",
            fontWeight: 540,
            letterSpacing: "-0.022em",
            lineHeight: 1.08
          }}>Bathroom Remodel Service Areas Near Lakeland, FL</h2>
            <p className="font-default text-[var(--muted-foreground)] max-w-xl" style={{
            fontSize: "clamp(1rem, 1.1vw, 1.125rem)",
            fontWeight: 400,
            lineHeight: 1.55
          }}>Request quotes for bathroom remodel projects in Lakeland and nearby Polk County communities. Service availability can vary by location, project type, and the remodeling business.</p>
          </div>
        </div>

        
        <div ref={map.ref} className="mt-12 md:mt-12" style={{
        opacity: map.isVisible ? 1 : 0,
        transform: map.isVisible ? "translateY(0)" : "translateY(8px)",
        transition: "opacity 420ms cubic-bezier(0.22, 1, 0.36, 1) 120ms, transform 420ms cubic-bezier(0.22, 1, 0.36, 1) 120ms"
      }}>
          <div className="relative w-full rounded-lg border border-[var(--border)] overflow-hidden" style={{
          backgroundColor: "hsl(220 15% 3%)",
          aspectRatio: "21 / 9"
        }}>
            <iframe src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d112744.44564564564!2d-81.8949!3d28.0395!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1710000000000!5m2!1sen!2sus" width="100%" height="100%" style={{
            border: 0,
            filter: "grayscale(1) invert(0.9) contrast(1.2)"
          }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Service Area Map" />
          </div>

          
          <div className="mt-4 flex flex-col md:flex-row md:items-center md:justify-between gap-2 border-t border-[var(--border)] pt-4">
            <div className="font-mono text-[var(--muted-foreground)] uppercase" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.02em"
          }}>LAKELAND FL · POLK COUNTY</div>
            <div className="font-mono text-[var(--muted-foreground)] uppercase" style={{
            fontSize: "0.75rem",
            letterSpacing: "0.02em"
          }}>REQUEST A FREE QUOTE</div>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes presencePulse {
          0% {
            box-shadow: 0 0 0 0 hsla(45, 90%, 50%, 0.6);
          }
          100% {
            box-shadow: 0 0 0 8px hsla(45, 90%, 50%, 0);
          }
        }
      `}</style>
    </section>;
}